import type { ComponentType, ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface PageHeaderProps {
  icon?: ComponentType<{ className?: string }>;
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
  testId?: string;
  className?: string;
}

/**
 * Cabecera de página estándar (UI-STD-1).
 *
 * Icono en azul corporativo (`text-primary`), título `text-2xl font-semibold`,
 * subtítulo atenuado y acciones que envuelven en móvil sin recortarse.
 */
export function PageHeader({
  icon: Icon,
  title,
  subtitle,
  actions,
  breadcrumb,
  testId,
  className,
}: PageHeaderProps) {
  return (
    <header
      className={cn(
        'flex flex-wrap items-start justify-between gap-3',
        className,
      )}
      data-testid={testId}
    >
      <div className="flex min-w-0 items-start gap-3">
        {Icon && (
          <Icon
            className="mt-0.5 h-6 w-6 shrink-0 text-primary"
            aria-hidden="true"
          />
        )}
        <div className="min-w-0">
          {breadcrumb}
          <h1 className="text-2xl font-semibold">{title}</h1>
          {subtitle && (
            <p className="text-sm text-muted-foreground">{subtitle}</p>
          )}
        </div>
      </div>
      {actions && (
        <div className="flex flex-wrap items-center gap-2">{actions}</div>
      )}
    </header>
  );
}
